module.exports = "/_next/static/files/0dfb3548353de795e45e946fd2c9f262.png";